import { phoneSize } from '@/assets/styles/mediaSize';
import { flexPos } from '@/assets/styles/mixin';
import useMessageStore from '@/store/messageStore';
import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';

const previewHeight = '800rem';
const headerHeight = '72rem';

const PcMediaPreviewWrap = styled.div<{ $show: boolean }>`
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: ${previewHeight};
  background-color: #f3f4f6;
  transform: translateY(-50%);
  border-radius: 16rem;
  overflow: hidden;

  z-index: 999;

  display: ${({ $show }) => ($show ? 'block' : 'none')};

  .img-content {
    width: 100%;
  }

  .icon-close {
    position: absolute;
    left: 48rem;
    top: 24rem;
    cursor: pointer;
    z-index: 9;
  }

  .preview-header {
    height: ${headerHeight};
    background-color: #fff;
  }

  .preview-content {
    width: 100%;
    height: calc(${previewHeight} - ${headerHeight});
    ${flexPos('center')}
    overflow: auto;

    /* > div {
      height: auto !important;
    } */
  }
`;

const PcMediaPreview: FC<{ show: boolean; children: ReactNode }> = ({ show, children }) => {
  const messageStore = useMessageStore();

  return (
    <PcMediaPreviewWrap $show={show}>
      <div className="preview-header">
        <img
          onClick={() => {messageStore.setShowPreviewMedia(false); window.parent && window.parent.postMessage({type: 'preview', visible: false}, '*')}}
          src={require('@img/common/icon-close.svg')}
          alt=""
          className="icon-close"
        />
      </div>
      <div className="preview-content">{children}</div>
    </PcMediaPreviewWrap>
  );
};

export default PcMediaPreview;
